<template>
  <div>
    <v-layout row wrap>
      <v-flex shrink>
        <h2 class="headline pb-3">We have</h2>
      </v-flex>
      <v-flex shrink>
        <NumberInputSpinner
          :min="0"
          :max="8"
          :step="1"
          :integerOnly="true"
          v-model="keyNumber"
          @change.stop="setKeyNumber(val)"
        />
      </v-flex>
      <v-flex>
        <h2 class="headline pb-3">Keys, {{borrowed}} borrowed</h2>
      </v-flex>
      <v-flex shrink>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn flat icon color="primary" @click.stop="borrowKey()" v-on="on">
              <v-icon class="mr-1">logout</v-icon>
            </v-btn>
          </template>
          <span>Borrow the keys</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-checkbox v-model="atlargeOnly" label="show borrowing keys only" color="primary"></v-checkbox>
    </v-layout>

    <v-expansion-panel class="elevation-0" focusable>
      <v-expansion-panel-content v-for="key in keys" :key="key.id">
        <template v-slot:header>
          <v-layout row wrap>
            <v-flex xs6 class="">
              {{ key.name }}
            </v-flex>
            <v-flex xs6 text-xs-right>
              <span class="pr-4" :class="key.state === 1? 'returned': 'atlarge'"  @click.stop="returnKey(key)">
                {{ key.state === 1? "Returned": "At Large" }}
              </span>
            </v-flex>
          </v-layout>
        </template>
        <div v-if="key.key_note && key.key_note.length > 0">
          <v-list>
            <v-list-tile v-for="notes in key.key_note" :key="notes.id">
              <v-list-tile-content>
                <v-layout row wrap>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip small class="filter" flat v-on="on">
                        {{ notes.account.account }}&nbsp;says&nbsp;
                      </v-chip>
                    </template>
                    <span>@ {{notes.time | moment('dddd, D MMM YYYY, h:mmA')}}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip small dark v-on="on">{{ notes.content }}</v-chip>
                    </template>
                    <span>@ {{notes.time | moment('dddd, D MMM YYYY, h:mmA')}}</span>
                  </v-tooltip>
                </v-layout>
              </v-list-tile-content>
              <v-list-tile-action>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <ConfirmDialog ref="dlg"/>
  </div>
</template>
<script>
import ConfirmDialog from '@/components/ConfirmDialog';
import NumberInputSpinner from 'vue-number-input-spinner'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import authHelper from '@/helpers/auth'
import alertHelper from '@/helpers/alert'

export default {
  name: 'DetailsKeys',
  components: {
    ConfirmDialog,
    NumberInputSpinner,
  },
  data() {
    return {
      atlargeOnly: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedHouse: 'HouseList/getSelectedHouse',
      allKeys: 'HouseList/Keys/getKeys',
    }),
    keyNumber: {
      get() {
        return this.selectedHouse.keyNumber;
      },
      set(v) {
        this.selectedHouse.keyNumber = v;
        this.updateHouse({
          id: this.selectedHouse.id,
          keyNumber: this.selectedHouse.keyNumber
        })
      },
    },
    borrowed() {
      const borrows = this.allKeys.filter(k => !k.state);
      console.log({borrows, allKeys: this.allKeys})
      return borrows.length
    },
    account() {
      return authHelper.getUser();
    },
    keys() {
      const keys = this.allKeys
      return this.atlargeOnly? keys.filter(k => !k.state): keys;
    }
  },
  methods: {
    ...mapActions({
      fetchKeys: 'HouseList/Keys/fetchKeys',
      upsertKey: 'HouseList/Keys/upsertKey',
      updateHouse: 'HouseList/updateHouse',
    }),

    setKeyNumber(val) {
      console.log('setKeyNumber', val)
    },

    async borrowKey() {
      if (!this.selectedHouse.keyNumber) {
        alertHelper.error('This house has no key to borrow')
        return;
      } else if (this.borrowed >= this.selectedHouse.keyNumber) {
        alertHelper.error('All keys are borrowed out')
        return;
      }
      try {
        const account = this.account
        const house_id = this.selectedHouse.id
        console.log('borrowKey', {account})
        const time = moment().toDate()
        const name = moment().format('ddd, D MMM YYYY')
        const content = await this.$refs.dlg.open(
          'Register to borrow a key',
          'Borrowed',
          {
            backgroundColor: 'yellow',
            color: 'navy',
            icon: 'content_paste',
            subTitle: 'Who borrows? For what?'
          })
        const newNote = {
          name,
          house_id,
          key_note: [{
            content
          }]
        }
        this.upsertKey(newNote)
        console.log('borrowKey', {newNote})
      }
      catch(reason) {
        console.log('exception in borrowKey', {reason})
      }
    },

    async returnKey(key) {
      if (key.state === 1) {
        return;
      }
      try {
        key = JSON.parse(JSON.stringify(key))
        const content = await this.$refs.dlg.open(
          'Returning a key',
          'Returned',
          {
            backgroundColor: 'yellow',
            color: 'navy',
            icon: 'content_paste',
            subTitle: 'Are you sure to return?'
          })
        key.state = 1;
        const account = this.account
        if (!key.key_note) {
          key.key_note = [];
        }
        key.key_note.push({
            content
        })
        this.upsertKey(key)
        console.log('returnKey', {key})
      }
      catch(reason) {
        console.log('exception in returnKey', {reason, key})
      }
    },
  },
  async mounted() {
    await this.fetchKeys();
  },
  watch: {
    keyNumber(newValue, oldValue) {
      console.log('watch: keyNumber', {newValue, oldValue})
    }
  }
}
</script>

<style lang="stylus" scoped>
.returned {
  color: navy;
}

.atlarge {
  color: red;
}

.filter {
  margin: 4px;
  height: 24px;
  color: primary;
}

.keyNumber {
  color: red;
}

</style>
